import React from "react";
import { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Input from "../../../frontend/UncontrolledInput";
import { TextField } from "../inputs";

export default function SignatureSection() {
  const [recaptcha, setRecaptcha] = useState("");

  return (
    <>
      <p>
        Please type your name and the date below to confirm your request, and
        then click submit.
      </p>
      <div className="form-row">
        <div className="form-item">
          <TextField
            label="Digital Signature (type full name)"
            name="data[signature]"
            required
          />
        </div>

        <div className="form-item">
          <TextField
            type="date"
            label="Date"
            name="data[signature_date]"
            required
          />
        </div>
      </div>
      <div className="center">
        <ReCAPTCHA
          sitekey="6LfOXSUcAAAAAHgluB7FB5JrlEDkeWj9O7lNHULc"
          onChange={(value) => setRecaptcha(value)}
        />
      </div>

      <Input type="hidden" name="g-recaptcha-response" value={recaptcha} />

      <div className="text-center">
        <button type="submit" className="btn-primary" disabled={!recaptcha}>
          Submit
        </button>
      </div>
    </>
  );
}
